import { render, staticRenderFns } from "./SampleMsg.vue?vue&type=template&id=cbb1dfa8&scoped=true"
import script from "./SampleMsg.vue?vue&type=script&lang=js"
export * from "./SampleMsg.vue?vue&type=script&lang=js"
import style0 from "./SampleMsg.vue?vue&type=style&index=0&id=cbb1dfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb1dfa8",
  null
  
)

export default component.exports